import React from 'react';

const config = {
  // Source List
  source: {
    // Table Columns
    columns: [
      {
        title: 'First Name',
        dataIndex: 'first_name',
        width: '180px',
        sorter: true
      },
      {
        title: 'Last Name',
        dataIndex: 'last_name',
        width: '180px',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        sorter: true
      }
    ],
    // Deleting
    confirmMessage: () => (
      <div />
    ),
    // Filtering
    sorter: {
      field: 'last_name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      first_name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['first_name'],
        searchValue: ''
      },
      last_name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['last_name'],
        searchValue: ''
      },
      email: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['email'],
        searchValue: ''
      }
    },
    // General
    title: 'Select Users',
    rowSelectionConfig: {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: true,
      multiRow: true,
      toggleRow: true
    }
  },
  // Destination List
  destination: {
    // General
    columns: [
      {
        title: 'First Name',
        dataIndex: 'first_name',
        width: '180px',
        sorter: true
      },
      {
        title: 'Last Name',
        dataIndex: 'last_name',
        width: '180px',
        sorter: true,
        defaultSortOrder: 'ascend'
      },
      {
        title: 'Email',
        dataIndex: 'email',
        sorter: true
      }
    ],
    // Filtering
    sorter: {
      field: 'last_name',
      order: 'ascend'
    },
    filters: {},
    customFilters: {
      first_name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['first_name'],
        searchValue: ''
      },
      last_name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['last_name'],
        searchValue: ''
      },
      email: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['email'],
        searchValue: ''
      }
    },
    title: 'Assigned Users',
    rowSelectionConfig: {
      selectItemOnSingleClick: false,
      selectItemOnDoubleClick: false,
      highlightRow: false,
      multiRow: false,
      toggleRow: false
    }
  }
};

export default config;
